import { useSelector, useDispatch } from 'react-redux';
import * as icons from 'react-bootstrap-icons';
import { useEffect, useState } from 'react';
import SelectComponent from 'Utils/Helpers/SelectComponent';
import moment from 'moment-jalaali';
import { get_byDate } from 'http/components/AppointmentService';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { SetAppointmentsData } from 'Utils/Helpers/HandleApiData';
import { setDate } from '../../../../Redux/slices/globalSlice';
import AppLanding from 'Screens/Home/Appointments/gridMode/Landing';

export default function Dashboard() {
    const dispatch = useDispatch();
    const { current, dateSearch, appointments, logs, searchTypes, searchStatus } = useSelector((state) => ({
        current: state.staff.current,
        dateSearch: state.setting.dateSearch,
        appointments: state.appointments.appointments,
        logs: state.appointments.logs,
        searchTypes: state.setting.searchTypes,
        searchStatus: state.setting.searchStatus,
    }));
    const [data, setData] = useState(appointments);
    const [status, setStatus] = useState();
    const [type, setType] = useState();

    useEffect(() => {
        const params = {
            date: moment().locale("fa").format("jYYYY/jMM/jDD"),
            dow: moment().day()
        };
        dispatch(setDate(params));
    },[dispatch])

    useEffect(() => {
        if(dateSearch.date) {
            (async () => {
                dispatch(HandleLoading(true));
                const response = await get_byDate(dateSearch.date);
                if(response.status) {
                    await dispatch(SetAppointmentsData(response.data));
                } else {
                    dispatch(HandleLoading(false));
                }
            })()
            // getData(dateSearch.date);
        }
    },[dispatch, dateSearch.date])

    useEffect(() => {
        if(searchTypes) setType(searchTypes.find(i => i.id === 0).access);
        if(searchStatus) setStatus(searchStatus.find(i => i.id === 0).access);
    },[searchTypes, searchStatus])

    // const getData = async (date) => {
    //     dispatch(HandleLoading(true));
    //     const response = await get_byDate(date);
    //     if(response.status) {
    //         await dispatch(SetAppointmentsData(response.data));
    //     } else {
    //         dispatch(HandleLoading(false));
    //     }
    // }

    const handleChangeStatus = (e) => {
        if(searchStatus) setStatus(searchStatus.find(i => i.id === +e).access);
    }

    const handleChangeType = (e) => {
        if(searchTypes) setType(searchTypes.find(i => i.id === +e).access);
    }

    useEffect( () => {
        if(appointments && type) {
            let newData = appointments.map(item => {
                if(type.includes(item.type) && status.includes(item.lastStatus)) return item;
                // else return undefined
            })
            setData(current[0][1] ? newData.filter(item => item !== undefined) : []);
        }
    }, [appointments, type, status, current])

    return (
        <div className='dashboard'>
            <div className='dashboard-search'>
                {
                    searchStatus &&
                    <SelectComponent
                        name={'appointment-type'}
                        icon={<icons.Back/>}
                        options={searchStatus}
                        onChange={handleChangeStatus}
                    />
                }
                {
                    searchTypes && searchTypes.length > 2 &&
                    <SelectComponent
                        name={'appointment-type'}
                        icon={<icons.Fingerprint/>}
                        options={searchTypes}
                        onChange={handleChangeType}
                    />
                }
            </div>
            {/* {
                data &&
                <div className="w-100">
                    <DataGridComponent
                        data={data}
                        columns={appointmentsList}
                    />
                </div>
            } */}
            <AppLanding
                data={data}
                logs={logs}
                withSection
            />
        </div>
    );
}